<template>
  <MainLayout>
    <h1 class="title">
      404
      <template v-if="resource">
        {{ resource }}
      </template>
      Not Found
    </h1>
  </MainLayout>
</template>

<script>
export default {
  metaInfo: {
    title: "404",
    meta: [{ name: "description", content: "404" }]
  },
  props: {
    resource: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.title {
  text-align: center;
}
</style>
